import { useEffect } from 'react'
import { useStore } from 'store/state/store'
import useAlgoPrice from 'api/hooks/useAlgoPrice'

export default function useAlgoUsd() {
  const setAlgoUsd = useStore((state) => state.setAlgoUsd)

  const { data, isSuccess } = useAlgoPrice({
    options: {
      staleTime: 5 * 60 * 1000 // 5 min
    }
  })

  useEffect(() => {
    if (data && isSuccess) {
      setAlgoUsd(data.usd || 0)
    }
  }, [data, isSuccess, setAlgoUsd])
}
